export enum CabinetBoxMaterialOptionsEnum {
  SPECIAL = 'Special',
}
